import actions from '../actionTypes';

const initialState = {
  currentPageIndex: 0,
  isPresetSizePage: true,
  pages: [],
  showCongratulationsPage: true
};

export default function pageControllerReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_PAGE_INDEX:
      return {
        ...state,
        currentPageIndex: action.payload.currentPageIndex
      };
    case actions.SETUP_PAGES:
      return {
        ...state,
        pages: action.payload.pages
      };
    case actions.SET_MODAL_PAGE_MODE:
      return {
        ...state,
        isPresetSizePage: action.payload.modalMode
      };
    case actions.REDIRECT_TO_CONGRATULATIONS_PAGE:
      return {
        ...state,
        showCongratulationsPage: action.payload
      };
    default:
      return state;
  }
}
